'use es6';

import { Record, List } from 'immutable';

class ExistingAdRecord extends Record({
  adStatus: null,
  descriptions: List(),
  finalUrls: List(),
  googleAdType: null,
  headlines: List()
}) {
  constructor({
    adStatus,
    descriptions,
    finalUrls,
    googleAdType,
    headlines
  } = {}) {
    super({
      adStatus,
      descriptions: List(descriptions),
      finalUrls: List(finalUrls),
      googleAdType,
      headlines: List(headlines)
    });
  }

}

export default ExistingAdRecord;